import { render } from "./FileSymlinkIcon.vue?vue&type=template&id=3cb60db4"
import script from "./FileSymlinkIcon.vue?vue&type=script&lang=js"
export * from "./FileSymlinkIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__